import { render, staticRenderFns } from "./exCl.vue?vue&type=template&id=0225a660&scoped=true&"
import script from "./exCl.vue?vue&type=script&lang=js&"
export * from "./exCl.vue?vue&type=script&lang=js&"
import style0 from "./exCl.vue?vue&type=style&index=0&id=0225a660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0225a660",
  null
  
)

export default component.exports